import type { ComponentPropsWithoutRef, ElementType } from 'react'

import styles from '@runtime/components/ui/StatText.module.scss'

type StatTextProps<E extends ElementType> = {
  as?: E
} & ComponentPropsWithoutRef<E>

export function ScoreText<E extends ElementType = 'div'>({
  as,
  className,
  ...props
}: StatTextProps<E>) {
  const Component = (as || 'div') as ElementType
  const classes = ['score', styles.score, className || '']
    .filter(Boolean)
    .join(' ')
  return <Component className={classes} {...props} />
}

export function ClockText<E extends ElementType = 'div'>({
  as,
  className,
  ...props
}: StatTextProps<E>) {
  const Component = (as || 'div') as ElementType
  const classes = ['clock', styles.clock, className || '']
    .filter(Boolean)
    .join(' ')
  return <Component className={classes} {...props} />
}
